<template>
    <div class=soundcloud-embed :class="[{ 'is-playing' : isPlaying }, {'is-loaded' : playerReady }]">

        <h4>{{ currentSoundTitle }}</h4>

        <div class=controls>

            <button class=prev @click="prev"></button>

            <button class=play @click="toggle"></button>

            <button class=next @click="next"></button>

        </div>

        <iframe width="1" height="1" style="opacity:0;position:absolute;left:-100000px" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1155299722&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=false"></iframe>

    </div>
</template>
<script>
export default {
    name : 'SoundCloudEmbed',
    props :  {
        url : String,
    },
    data() {
        return {
            elem                : null ,
            player              : null ,
            playerReady         : false,
            currentSoundIndex   : null ,
            currentSoundTitle   : 'Loading...'   ,
            isPlaying           : false,
        }
    },
    methods : {
        play() {
            this.player.play();
        },
        pause() {
            this.player.pause();
        },
        next() {
            this.player.next();
            this.$emit('next', this.getCurrentSoundIndex() );
        },
        prev() {
            if( this.currentSoundIndex > 0 ) {
                this.player.prev();
                this.$emit('prev', this.getCurrentSoundIndex() );
            }
        },
        skipTo( index ) {
            if( this.currentSoundIndex !== index ) {
                this.player.skip( index );
            }
        },
        toggle() {
            this.isPlaying ? this.player.pause() : this.player.play();
        },
        getCurrentSoundIndex() {
            this.player.getCurrentSoundIndex( index => { console.log(index); this.currentSoundIndex = index });
            return this.currentSoundIndex;
        },
        getCurrentSoundTitle() {
            this.player.getCurrentSound( sound => { this.currentSoundTitle = sound.title; });
            return this.currentSoundTitle;
        },
        scriptLoaded() {
            // SoundCloud Widget API.
            const SC = window.SC;

            this.elem = document.querySelector('.soundcloud-embed iframe');
            this.player = SC.Widget(this.elem);

            this.player.bind(SC.Widget.Events.READY, () => {
                this.playerReady = true;
                this.getCurrentSoundTitle();
                this.getCurrentSoundIndex();
            } );

            this.player.bind(SC.Widget.Events.PLAY, () => {
                this.$emit('playing', this.getCurrentSoundIndex() );
                this.isPlaying = true;
                this.getCurrentSoundTitle();
            } );

            this.player.bind(SC.Widget.Events.PAUSE, () => {
                this.$emit('pause', this.getCurrentSoundIndex() );
                this.isPlaying = false;
            } );

            this.player.bind(SC.Widget.Events.FINISH, () => {
                this.$emit( 'finished' );
            } );
        },
    },
    mounted() {
        let script = document.createElement('script');
        script.src = 'https://w.soundcloud.com/player/api.js';
        script.async = false;
        document.body.append(script);

        script.onload = this.scriptLoaded;
    }
}
</script>